import { isEmpty } from "lodash";

export default function numGenerate ({prev=''}){
    const date = new Date();

    return (
        `${prev || ''}${date.getFullYear()}${date.getMonth()+1}${date.getDate()}_${date.getHours()}${date.getMinutes()}${date.getSeconds()}${!isEmpty(prev) ? '': ' _AC_F'}`
    );
}
